import { render, staticRenderFns } from "./Incidents.vue?vue&type=template&id=53da2ddf&scoped=true&"
import script from "./Incidents.vue?vue&type=script&lang=ts&"
export * from "./Incidents.vue?vue&type=script&lang=ts&"
import style0 from "./Incidents.vue?vue&type=style&index=0&id=53da2ddf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53da2ddf",
  null
  
)

export default component.exports